import { render, staticRenderFns } from "./day.vue?vue&type=template&id=2fdeea35&scoped=true"
import script from "./day.vue?vue&type=script&lang=js"
export * from "./day.vue?vue&type=script&lang=js"
import style0 from "./day.vue?vue&type=style&index=0&id=2fdeea35&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdeea35",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/prod2/jobs/build/partner-assets-build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fdeea35')) {
      api.createRecord('2fdeea35', component.options)
    } else {
      api.reload('2fdeea35', component.options)
    }
    module.hot.accept("./day.vue?vue&type=template&id=2fdeea35&scoped=true", function () {
      api.rerender('2fdeea35', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vab/components/VabCalendar/components/day.vue"
export default component.exports